export const mlScoreSliderSettings = Object.freeze({
  mlScoreRanges: [0.3, 0.5],
  mlScoreColors: ["#808080", "#FFFF00", "#008000"]
});
